import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';
import 'moment/locale/de';

// Importing a moment locale switches the global default; reset it so only this pipe is localized.
moment.locale('en');

@Pipe({
    standalone: false,
    name: 'timeAgo'
})
export class TimeAgo implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

    transform(value?: string | Date | null): string {
        if (!value) {
            return '';
        }

        return moment(value).locale(this.locale).fromNow();
    }
}
